import { ProcessorDetails } from '@/lib/api/processors'
import { ProcessorHeader } from '../components/processor-header'
import { ProcessorOverviewCard } from '../components/processor-overview-card'
import { ProcessorMetricsCard } from '../components/processor-metrics-card'
import { BakolaPayConfigurationCard } from './components/bakolapay-configuration-card'
import { BakolaPayDescriptorCard } from './components/bakolapay-descriptor-card'
import { BakolaPayFeaturesCard } from './components/bakolapay-features-card'
import { ProcessorPaymentMethodsCard } from '../components/processor-payment-methods-card'

interface BakolaPayProcessorDetailsPageProps {
    processor: ProcessorDetails
}

export const BakolaPayProcessorDetailsPage = ({ processor }: BakolaPayProcessorDetailsPageProps) => {
    return (
        <>
            <ProcessorHeader
                type="bakolapay"
                processor={processor}
            />
            <ProcessorOverviewCard processor={processor} />
            <ProcessorMetricsCard processor={processor} />
            <BakolaPayConfigurationCard processor={processor} />
            <BakolaPayDescriptorCard processor={processor} />
            <ProcessorPaymentMethodsCard processor={processor} />
            <BakolaPayFeaturesCard />
        </>
    )
}
